import giftClient, { GenerateGreetPayload } from "../../../../api/gift";
import useEditorMutation, {
  UseEditorMutationOptions,
} from "../../../../hooks/useEditorMutation";

const useGenerateGreetMutation = (
  options: UseEditorMutationOptions<string, GenerateGreetPayload>,
) => {
  return useEditorMutation({
    ...options,
    mutationFn: (payload: GenerateGreetPayload) =>
      giftClient.generateGreet(payload),
  });
};

export default useGenerateGreetMutation;
